// Requires f64/dekker.wgsl concatenated first for the DD struct, and
// f64/utils/add.wgsl for ddAddProtected.
//
// Not part of the vendored wgblas copy (wgblas' own reductions never needed
// subtraction) — this app's own addition on top of it, for cdMul's re*re -
// im*im term in f64/complex.wgsl.

// Negation is exact for a double-double pair — no rounding happens, so
// (unlike ddAbs's sign flip, which at least branches on sign) it's just two
// unconditional sign flips.
fn ddNeg(a: DD) -> DD {
  return DD(-a.hi, -a.lo);
}

// a - b, protected the same way ddAddProtected is (see add.wgsl's header) —
// literally addition of the negation. Negating introduces no new rounding
// for the compiler bug ddAddProtected guards against to zero out, so no
// extra protection is needed beyond what ddAddProtected already does.
fn ddSubProtected(a: DD, b: DD, threadSlot: u32) -> DD {
  return ddAddProtected(a, ddNeg(b), threadSlot);
}
